import { Injectable } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private MAX_HISTORY_LEN = 50; // prevent history from growing indefinitely
  private history: string[] = [];
  private isReplacing = false;

  constructor(private router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const currentNav = this.router.getCurrentNavigation();
        this.isReplacing = currentNav?.extras?.replaceUrl ?? false;
      }

      if (event instanceof NavigationEnd) {
        if (this.isReplacing && this.history.length > 0) {
          this.history.pop();
        }

        this.history.push(event.urlAfterRedirects);
        if (this.history.length > this.MAX_HISTORY_LEN) {
          this.history.shift();
        }
        this.isReplacing = false;
      }

      if (event instanceof NavigationCancel || event instanceof NavigationError) {
        this.isReplacing = false;
      }
    });
  }

  back() {
    if (this.history.length > 1) {
      this.history.pop(); // the current route
      this.router.navigateByUrl(this.history.pop()!); // go back
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
